module.exports = __webpack_public_path__ + "static/media/developer.a73310ea.svg";